/**
 * 패키지 코드
 * 애플리케이션 패키지 구분 코드
 */
export const PACKAGE_CODE = {
  GAME: 'GAME',
  MEDIA: 'MEDIA',
  VISUAL: 'VISUAL',
  COMMERCE: 'COMMERCE',
} as const;

/**
 * 플랫폼 코드
 * 플랫폼 구분 코드
 */
export const PLATFORM_CODE = {
  VARCO_SAAS: 'VARCO_SAAS',
  VAETKI_SAAS: 'VAETKI_SAAS',
} as const;

/**
 * 서비스 코드
 * 서비스 구분 코드
 */
export const SERVICE_CODE = {
  THREE_D: '3D',
  SOUND: 'SOUND',
  SYNCFACE: 'SYNCFACE',
  VOICE: 'VOICE',
  TRANSLATION: 'MEDIATRANS',
  ACCOUNT: 'ACCOUNT',
  COMMERCE: 'COMMERCE',
} as const;

/**
 * 통화 코드
 * ISO 4217 표준 통화 코드
 */
export const CURRENCY = {
  USD: 'USD',
  KRW: 'KRW',
  EUR: 'EUR',
  JPY: 'JPY',
} as const;

/**
 * 재화 소모 단위
 * 크레딧, API 사용 횟수 등의 단위 구분
 */
export const USAGE_UNIT = {
  CREDIT: 'CREDIT',
} as const;

/**
 * 결제 주기 단위
 * 구독 결제의 주기 단위 (일, 주, 월, 년)
 */
export const PERIOD_UNIT = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
} as const;

/**
 * 구독 상태
 * 엔타이틀먼트(구독)의 현재 상태
 */
export const ENTITLEMENT_STATUS = {
  /** 결제 대기 중 */
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  /** 구독 중 */
  ACTIVE: 'ACTIVE',
  /** 유예 기간 */
  GRACE: 'GRACE',
  /** 중단됨 */
  SUSPENDED: 'SUSPENDED',
  /** 취소됨 */
  CANCELLED: 'CANCELLED',
  /** 만료됨 */
  EXPIRED: 'EXPIRED',
} as const;

/**
 * 결제 유형
 * 결제 방식 구분
 */
export const PAYMENT_TYPE = {
  /** 일반 결제 (일회성) */
  ONE_TIME: 'ONE_TIME',
  /** 구독 결제 */
  SUBSCRIPTION: 'SUBSCRIPTION',
  /** 무료 */
  NONE: 'NONE',
} as const;
